import { useEffect, useState } from "react";
import { packStats, type BobStatsResponse } from "../../api/bobReports";
import { reviewTally } from "../../lib/bobReports";

const TALLY_DAYS = 180;

/** How many reviews Bob ran on this pack, and for an admin what they cost. Absent when the stats read fails. */
export default function ReviewTally({ project, isAdmin }: { project: string; isAdmin: boolean }) {
  const [read, setRead] = useState<{ project: string; stats: BobStatsResponse } | null>(null);
  useEffect(() => {
    let live = true;
    packStats(project, TALLY_DAYS)
      .then((stats) => { if (live) setRead({ project, stats }); })
      .catch(() => { if (live) setRead(null); });
    return () => { live = false; };
  }, [project]);
  const text = read !== null && read.project === project ? reviewTally(read.stats, isAdmin) : null;
  if (text === null) return null;
  return <span className="bob-head-tally" title={`Bob's reviews of this pack in the last ${TALLY_DAYS} days`}>{text}</span>;
}
